(function cmpExpand() {
  var btn = document.querySelector('[data-cmp-expand]');
  if (!btn) return;
  if (btn.dataset.cmpInit) return;
  btn.dataset.cmpInit = '1';

  var table = document.querySelector('.cmp-table-5');
  if (!table) return;
  var label = btn.querySelector('.cmp-expand-label');

  btn.addEventListener('click', function () {
    var isExpanded = table.getAttribute('data-expanded') === 'true';
    if (isExpanded) {
      table.removeAttribute('data-expanded');
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = 'See all 13 criteria';
    } else {
      table.setAttribute('data-expanded', 'true');
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = 'Show less';
    }
  });
})();
